
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Multiselect from 'vue-multiselect'
// import moment from 'moment'
import xlsx from 'json-as-xlsx'
// import pdfMake from 'pdfMake'

import {
  getCalculatorResolve,
  updateBillingSemesterList
} from '@/components/patients/patients.service'
import {
  getDiagnostics,
  updateDiagnosticStatus,
  deleteDiagnostic,
  deleteAllDiagnostics,
  postRecordDiagnosticTemp,
  getLastRecord
} from '@/components/diagnostics/diagnostics.service'
import {
  CalculatorForm,
  Diagnostic,
  PaginationVM,
  PatientInfo,
  PostRecordDiagnosticTemp,
  RecordDiagnostic,
  RecordDiagnosticTempResult,
  Role,
  SelectVM,
  UpdateBillingSemester,
  UpdateDiagnosticStatus
} from '@/models'
import moment from 'moment'

/* eslint-disable */
// @ts-ignore
import vueShowMoreText from 'vue-show-more-text'
/* eslint-enable */
import { Debounce } from 'typescript-debounce'
import { namespace } from 'vuex-class'
import {
  postDoctorNote,
  postMAGNote
} from '@/components/doctors/doctors.service'
import {
  getCurrentUser,
  getUserRole
} from '@/components/admin/users/users.service'
import PdfMake from 'pdfmake'

const AppModule = namespace('app')
@Component({
  components: {
    vueShowMoreText,
    Multiselect
  }
})
export default class CalculatorView extends Vue {
  @Prop() private recordID!: string
  @AppModule.Getter
  public _closeModal!: () => boolean
  public patientInfo = {} as PatientInfo
  public note: string | null = null
  public recordDiagnostics: RecordDiagnosticTempResult[] = []
  public isLoading = false
  public fields = [
    {
      key: 'index',
      label: 'Index',
      tdClass: 'align-middle',
      exportable: false
    },

    {
      key: 'diagnosticID',
      label: 'Code',
      tdClass: 'align-middle',
      order: 1,
      exportable: true
    },
    {
      key: 'descriptions',
      label: 'Description',
      tdClass: 'align-middle',
      order: 2,
      exportable: true
    },
    {
      key: 'documentation',
      label: 'Documentation',
      tdClass: 'align-middle'
    },
    {
      key: 'cmsHcc1',
      label: 'CMSHcc1',
      tdClass: 'align-middle',
      order: 3,
      exportable: true
    },
    {
      key: 'cmsHcc2',
      label: 'CMSHcc2',
      tdClass: 'align-middle',
      order: 4,
      exportable: true
    },
    {
      key: 'rxHcc1',
      label: 'RxHcc1',
      tdClass: 'align-middle',
      order: 5,
      exportable: true
    },
    {
      key: 'crosswalkDx',
      label: 'CrosswalkDx',
      tdClass: 'align-middle',
      order: 5,
      exportable: false
    },
    {
      key: 'crosswalkRx',
      label: 'CrosswalkRx',
      tdClass: 'align-middle',
      order: 6,
      exportable: false
    }
    // {
    //   key: "idInteraction",
    //   label: "ID Interaction",
    // },
    // {
    //   key: 'actions',
    //   label: 'Active',
    //   tdClass: 'align-middle',
    //   order: 11,
    //   exportable: true
    // },
    // {
    //   key: 'deleteAction',
    //   label: '',
    //   tdClass: 'align-middle',
    //   exportable: false
    // }
  ]
  public value: RecordDiagnostic[] = []
  public options: Diagnostic[] = []
  public genders: SelectVM[] = []
  public plans: SelectVM[] = []
  public selectedPlan = {} as SelectVM
  public selectedGender = {} as SelectVM

  public addByList = false
  public diagnosticList = ''
  public tabIndex = 0
  public expandAllRows = false
  public perPage = 10
  public pageOptions = [10, 20, 50, 100, 250, 500, 1000]
  public pagination = {} as PaginationVM
  public expandedNotes = false
  public noteTitle = 'Doctor'
  public type = 1
  public isMAG = false
  public currentUser = ''
  public selectedSemester = 1
  public recordId = ''
  public age = ''
  public patientName = ''
  // public showOptimizer = true
  public optimizerFlag = true
  public printMode = false
  public readOnly = false
  public showPrint = false
  public showDelete = false
  public exportable = false
  public showFast = false
  public formatted = ''
  public calculatorForm = {} as CalculatorForm

  public pdf = {
    footer: function(currentPage, pageCount) {
      return [
        {
          columns: [
            {
              text: currentPage.toString() + ' of ' + pageCount,
              alignment: 'left',
              margin: [40, 40]
            },
            { width: '*', text: '' },
            {
              width: 'auto',
              layout: 'noBorders',
              fontSize: 12,
              table: {
                body: [
                  ['', 'Powered By', ''],
                  [
                    '',
                    {
                      image:
                        'data:image/jpeg;base64,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',
                      width: 100,
                      height: 50
                    },
                    ''
                  ]
                ]
              }
            }

            // { width: '*', text: '' }
          ]
        }
      ]
    },
    pageOrientation: 'landscape',
    pageMargins: [40, 40, 40, 100],
    content: [],
    styles: {
      filledHeader: { bold: true, fillColor: '#024c88', color: 'white' },
      header: { bold: true }
    }
  }
  @Watch('perPage')
  perPageChange() {
    // this._getRecordDiagnostics()
    console.log(1)
  }
  public onContext(ctx) {
    this.formatted = moment(ctx).format('MM/DD/YYYY')
  }
  public print() {
    this.expandAllRows = true
    this.printMode = true
  }
  public calculate() {
    console.log(1)
  }
  public onInput(ctx) {
    const a = moment(ctx).toDate()
    if (a.toString() != 'Invalid Date') this.calculatorForm.dob = a
  }
  public getYears() {
    // console.log(this.calculatorForm)
    if (this.calculatorForm.dob) {
      return Math.abs(moment(this.calculatorForm.dob).diff(new Date(), 'years'))
    } else {
      return 0
    }
  }
  public printPage() {
    this.pdf.content = []
    // console.log(this.fields.flatMap(c => c.label))
    const arr = [
      'expand',
      'crosswalkDx',
      'crosswalkRx',
      'alert',
      'actions',
      '_showDetails',
      'diagnosticDate',
      'diagnostic',
      'diagnosticStatus',
      'delete',
      ''
    ]
    const columns = this.fields
      .filter(c => !arr.includes(c.key))
      .map(c => {
        c.key === 'billingFSM' ? (c.label = 'BFS') : c.label
        c.key === 'billingSSM' ? (c.label = 'BSS') : c.label

        return {
          text: c.label,
          style: {
            fillColor: '#024c88',
            color: 'white',
            bold: true
          }
        }
      })
      .filter(c => c.text)

    // console.log(columns)
    const userInfo = {
      layout: 'noBorders',
      style: {
        fontSize: 11
      },

      table: {
        // widths: ['auto', 'auto', 'auto',''],

        body: [
          ['', '', '', ''],
          [
            {
              image:
                'data:image/png;base64,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',
              height: 80,
              width: 80
            },
            {
              layout: 'noBorders',
              style: {
                fontSize: 11
              },

              table: {
                // widths: ['*'],

                body: [
                  [''],
                  // [
                  //   `${this.patientInfo.fullName} - ${this.patientInfo.insuranceContractNo}`
                  // ],
                  // [`Record - ${this.recordID}`],
                  // [`Fecha - ${this.formatDate(this.patientInfo.recordDate)}`],
                  [
                    `${this.patientInfo.insuranceName} - ${this.patientInfo.plan}`
                  ],
                  [`DOB: ${this.formatDate(this.patientInfo.dob)}`],
                  [
                    `Sex: ${this.patientInfo.sex} - Status: ${
                      this.patientInfo.patientStatus ? 'Active' : 'Inactive'
                    } `
                  ]
                  // [
                  //   `Status: ${
                  //     this.patientInfo.patientStatus ? 'Active' : 'Inactive'
                  //   }`
                  // ]
                ]
              }
            },

            {
              layout: 'noBorders',
              style: {
                fontSize: 11
              },

              table: {
                body: [
                  ['', ''],
                  [
                    {
                      image:
                        'data:image/png;base64,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',
                      height: 80,
                      width: 80
                    },
                    {
                      layout: 'noBorders',
                      style: {
                        // margin: [0, 0, 0, 0],
                        fontSize: 11
                      },
                      table: {
                        // widths: ['*'],

                        body: [
                          ['RAF'],
                          [
                            `Total: ${
                              this.patientInfo.raF_TOTAL
                                ? this.patientInfo.raF_TOTAL.toFixed(2)
                                : 0
                            }`
                          ],
                          [
                            {
                              text: `BFS: ${
                                this.patientInfo.raF_TOTAL_BilledFSM
                                  ? this.patientInfo.raF_TOTAL_BilledFSM.toFixed(
                                      2
                                    )
                                  : 0
                              } - ${(this.patientInfo.percentage_BFSM
                                ? this.patientInfo.percentage_BFSM * 100
                                : 0
                              ).toFixed(2)}%`,
                              style: {
                                width: 100
                              }
                            }
                          ],
                          [
                            `BSS: ${
                              this.patientInfo.raF_TOTAL_BilledSSM
                                ? this.patientInfo.raF_TOTAL_BilledSSM.toFixed(
                                    2
                                  )
                                : 0
                            } - ${(this.patientInfo.percentage_BSSM
                              ? this.patientInfo.percentage_BSSM * 100
                              : 0
                            ).toFixed(2)}%`
                          ]
                        ]
                      }
                    }
                  ]
                ]
              }
            },
            {
              layout: 'noBorders',
              style: {
                fontSize: 11
              },
              table: {
                body: [
                  ['Doctor Notes', 'MAG Notes'],
                  // ['Doctor Notes', ''],
                  [
                    this.patientInfo.doctorNotes ||
                      'There are no notes for this \n record',
                    this.patientInfo.magNotes ||
                      'There are no notes for this record'
                  ]
                ]
              }
            }
          ]
        ]
      }
    }

    const table = {
      table: {
        body: [[...columns]]
      },
      layout: {
        fillColor: function(rowIndex, node, columnIndex) {
          return rowIndex % 2 === 0 ? '#F2F2F2' : null
        }
      }
    }
    table['fontSize'] = 11
    // console.log(table)
    // console.log(this.recordDiagnostics.map(c => Object.keys(c)))

    const a = this.recordDiagnostics.map(c => {
      // console.log(c.billingFSM)

      return Object.entries(c)
        .filter(([key, val]) => !arr.includes(key))
        .map(([k, v]) => {
          // if (c[k] == true) {
          //   c[k] = 'Yes'
          // }
          if (v == true) {
            v = 'Yes'
          }
          if (v == false) {
            v = 'No'
          }
          // v == true ? 'Yes' : ''
          // console.log(v)
          return v
        })
    })

    a.map((c: string[], index) => {
      c.unshift((index + 1).toString())
      table['table']['body'].push(c)
    })

    this.pdf.content.push(userInfo)
    // this.pdf.content.push(raf)

    this.pdf.content.push(table)

    this.pdf['header'] = [
      {
        margin: [20, 5],
        text: `Member: ${this.patientInfo.fullName} - ${this.patientInfo.insuranceContractNo}`,
        alignment: 'right',
        style: {
          bold: true,
          fontSize: 14
        }
      }
    ]

    // header: function(currentPage, pageCount, pageSize) {
    //   // you can apply any logic and return any valid pdfmake element

    //   return [{ text: this.patientInfo.fullName, alignment: 'right' }]
    // },

    // console.log(this.pdf)

    PdfMake.createPdf(this.pdf).open()
    // console.log('Printing completed...')

    // this.perPage = this._pagination.totalCount
    // this.fields = this.fields.filter(c => !arr.includes(c.key))
    // // this.recordDiagnostics = this.recordDiagnostics.map(c => {
    // //   return { ...c, _showDetails: true }
    // // })
    // // this.expandAllRows = true
    // this.printMode = true

    // setTimeout(() => {
    //   window.print()
    // }, 1000)
    // window.onbeforeprint = event => {
    //   console.log(event)
    //   this.expandAllRows = true
    //   this.printMode = true
    // }
    // window.print()
    // console.log(this.$htmlToPaper('printMe'))
  }
  public async exportTable() {
    let items = []
    //await getRecordDiagnostics(1, 999999, this.recordID)
    items = this.recordDiagnostics

    // console.log(items)
    const updatedArray = items.map(obj => {
      const newObj = {}
      // Sort the first array based on the order property
      this.fields.sort((a, b) => a.order - b.order)
      // Get the keys in the order specified by the first array
      const keys = this.fields.filter(c => c.exportable).map(x => x.key)
      // Sort the keys of the object
      keys.forEach(key => {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          const label = this.fields.find(x => x.key === key).label
          newObj[label.toLowerCase()] = obj[key.toLowerCase()]
        }
      })
      return newObj
    })
    // console.log(updatedArray)
    const data = [
      {
        sheet: 'Patient Info',
        columns: [],
        content: []
      },
      {
        sheet: 'Diagnostics Report',
        columns: [],
        content: []
      }
    ]

    data[1].columns = this.fields
      .map(c => {
        return {
          label: c.label,
          value: c.key
        }
      })
      .filter(
        c =>
          c.value != 'index' &&
          c.value != 'actions' &&
          c.value != 'crosswalkRx' &&
          c.value != 'crosswalkDx' &&
          c.value != 'documentation' &&
          c.value != 'alert'
      )

    data[1].content = items.map(c => {
      return {
        ...c
        // billingFSM: c.billingFSM ? 'Yes' : 'No',
        // billingSSM: c.billingSSM ? 'Yes' : 'No'
      }
    })
    data[0].columns = [
      { label: 'Record Id', value: 'recordId' },

      { label: 'Full Name', value: 'patientName' },
      { label: 'Insurance Contract Number', value: 'insuranceContractNo' },
      { label: 'Insurance Name', value: 'insuranceName' },
      { label: 'Plan', value: 'plan' },
      { label: 'Date of Birth', value: 'dob' },
      { label: 'Gender', value: 'gender' },
      { label: 'Status', value: 'status' },
      { label: 'Gender', value: 'gender' },
      { label: 'Total Raf', value: 'totalRaf' },
      { label: 'Billing First Semester', value: 'bfs' },
      { label: 'Billing Second Semester', value: 'bss' },
      { label: 'Doctor Notes', value: 'notes' },
      { label: 'Mag Notes', value: 'magNotes' }
    ]
    data[0].content = [
      {
        fullName: this.calculatorForm.patientName,
        insuranceContractNo: this.patientInfo.insuranceContractNo,
        insuranceName: this.patientInfo.insuranceName,
        plan: this.patientInfo.plan,
        dob: this.formatDate(this.patientInfo.dob.toString()),
        gender: this.patientInfo.sex,
        status: this.patientInfo.patientStatus ? 'Active' : 'Inactive',

        totalRaf: this.patientInfo.raF_TOTAL
          ? this.patientInfo.raF_TOTAL.toFixed(2)
          : 0,
        bfs: `${
          this.patientInfo.raF_TOTAL_BilledFSM
            ? this.patientInfo.raF_TOTAL_BilledFSM.toFixed(2)
            : 0
        } - ${(this.patientInfo.percentage_BFSM
          ? this.patientInfo.percentage_BFSM * 100
          : 0
        ).toFixed(2)}%`,
        bss: `${
          this.patientInfo.raF_TOTAL_BilledSSM
            ? this.patientInfo.raF_TOTAL_BilledSSM.toFixed(2)
            : 0
        } - ${(this.patientInfo.percentage_BSSM
          ? this.patientInfo.percentage_BSSM * 100
          : 0
        ).toFixed(2)}%`,
        notes: this.patientInfo.doctorNotes,
        magNotes: this.patientInfo.magNotes
      }
    ]
    // dob: '1945-01-01T00:00:00'
    // doctorNotes: null
    // documentID: '0002-0125237213'
    // fullName: 'Pedro Del Campo'
    // insuranceContractNo: '0125237213'
    // insuranceName: 'MMM/PMC'
    // magNotes: 'Esto es una prueba 2'
    // patientStatus: true
    // percentage_BFSM: 0.7089245847414327
    // percentage_BSSM: 0.507726237292574
    // plan: 'FullMedicare  '
    // raF_TOTAL: 3.1710002
    // raF_TOTAL_BilledFSM: 2.248
    // raF_TOTAL_BilledSSM: 1.6099999999999999
    // recordDate: '2022-01-11T00:00:00'
    // recordID: 'MAG-00000002'
    // sex: 'M'
    // console.log(this.patientInfo)
    const settings = {
      fileName: `${this.patientInfo.fullName} - Diagnostics Report`, // Name of the resulting spreadsheet
      extraLength: 1, // A bigger number means that columns will be wider
      writeMode: 'writeFile', // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
      writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
      RTL: false // Display the columns from right-to-left (the default value is false)
    }
    console.log(data)
    xlsx(data, settings) // Will download the excel file
  }
  public formatMoney(value) {
    return new Intl.NumberFormat('us-US', {
      style: 'currency',
      currency: 'USD'
    }).format(value)
  }
  public reset() {
    this.recordDiagnostics = []
    this.selectedGender = null
    this.selectedPlan = null
    this.diagnosticList = ''
    this.calculatorForm.sex = null
    this.calculatorForm.plan = null
    this.calculatorForm.dob = null
  }
  public async onPageChange(pageNumber: number) {
    this.expandAllRows = false
    // await this._getRecordDiagnostics(pageNumber)
  }
  private async created() {
    this.currentUser = getCurrentUser()
    await this.fillData()

    const a = await getLastRecord()
    // [
    //   {
    //     recordID: 'asdd',
    //     patientName: 'Johnny',
    //     age: '30',
    //     dob: new Date('2022-03-03'),
    //     sex: 'M',
    //     plan: 'FullMedicare',
    //     raf: 300,
    //     diagnosticID: 'I309',
    //     descriptions: 'this is a desc'
    //   },
    //   {
    //     recordID: 'asdd',
    //     patientName: 'Johnny',
    //     raf: 300,
    //     dob: new Date('2022-03-03'),
    //     age: '30',
    //     sex: 'M',
    //     plan: 'FullMedicare',
    //     diagnosticID: 'M00',
    //     descriptions: 'this is a desc2'
    //   }
    // ]
    // console.log(a)
    if (a.length > 0) {
      const _genders = this.genders
      const _plans = this.plans

      this.recordDiagnostics = a
      this.diagnosticList = a.map(c => c.diagnosticID).join('\n')
      this.calculatorForm = a.map(c => {
        return {
          recordID: c.recordID,
          patientName: c.patientName,
          dob: c.dob,
          sex: _genders.filter(m => m.label == c.sex)[0],
          plan: _plans.filter(m => m.label.trim() == c.plan.trim())[0]
        }
      })[0]
    } else {
      this.calculatorForm = {
        dob: null,
        patientName: null,
        plan: null,
        recordID: null,
        sex: null
      }
    }
    this.formatted = this.formatDate(this.calculatorForm.dob.toString())
    // console.log(_plans)
  }
  get _pagination() {
    return this.pagination
  }
  public cleanLists() {
    this.value = [] as RecordDiagnostic[]
    this.diagnosticList = ''
  }
  public expandNote(type: number) {
    this.expandedNotes = true
    this.noteTitle = 'Doctor'
    this.type = type
    if (!this.expandedNotes) {
      this.note = null
    }
    if (type === 2) {
      this.noteTitle = 'MAG'
      this.note = this.patientInfo.magNotes
    } else {
      this.note = this.patientInfo.doctorNotes
    }
  }

  private async fillData() {
    const userRole = getUserRole()
    this.isMAG =
      userRole === Role.Superuser ||
      userRole === Role.Staff ||
      userRole === Role.Admin ||
      userRole === Role.Training
    if (!this.isMAG) {
      this.optimizerFlag = false
    } else {
      this.showDelete = true
    }
    if (userRole === Role.InsuranceStaff) {
      this.readOnly = true
    }
    if (
      userRole === Role.Admin ||
      userRole === Role.Superuser ||
      userRole == Role.Staff
    ) {
      this.exportable = true
    } else {
      this.exportable = false
    }
    const r = await getCalculatorResolve()
    this.genders = r.genders
    this.plans = r.insurancePlans
  }

  public formatDate(value: string) {
    return moment(value).format('MM/DD/YYYY')
  }
  public goBack() {
    this.$router.push({ name: 'PatientsView' })
  }

  @Debounce({ millisecondsDelay: 1000 })
  public _getDiagnostics(value: any): void {
    if (value.length >= 3) {
      getDiagnostics(1, 10, value).then(r => {
        this.options = r.data
      })
    }
  }

  public async create() {
    let diagnostics = this.value.map(v => v.diagnosticId.trim()).join(',')
    if (!this.diagnosticList) return
    diagnostics = this.diagnosticList.split('\n').join(',')

    if (!diagnostics) return
    const obj: PostRecordDiagnosticTemp = {
      recordID: this.calculatorForm.recordID,
      diagnostics: diagnostics,
      optimizerFlag: this.optimizerFlag,
      dob: moment(this.calculatorForm.dob).format('yyyy-MM-DD'),
      patientName: this.calculatorForm.patientName,
      plan: this.calculatorForm.plan.label,
      sex: this.calculatorForm.sex.label
    }
    // console.log(obj)
    const resp = await postRecordDiagnosticTemp(obj)
    this.recordDiagnostics = resp
    this.$root.$emit('bv::hide::modal', 'modal', '#btnCreate')
  }
}
